import { Storage } from "@faire/web--source/common/Storage";
import { IOption } from "@faire/web--source/slate/Input/Dropdown/index";
import { useEffect } from "react";

import { ICountry } from "@faire/retailer/views/apply/MakerApplication/MakerSignUpState";

export interface IInboundApplicationFormData {
  companyName?: string;
  url?: string;
  email?: string;
  stockists?: number;
  numProducts?: number;
  categoryOption?: IOption;
  country: ICountry;
  phoneNumber?: string;
}

const FORM_DATA_KEY = "MAKER_INBOUND_APPLICATION_FORM_DATA";

export const MAKER_APPLICATION_DEFAULT_FORM_DATA: IInboundApplicationFormData =
  {
    country: {
      isoCode: "",
      displayName: "",
    },
  };

export const useMakerApplicationDataForm = (
  defaultData?: IInboundApplicationFormData
) => {
  useEffect(() => {
    if (!getFormData() && defaultData) {
      setData(defaultData);
    }
  }, [defaultData]);

  const getFormData = () => {
    const data = Storage.local.getItem(FORM_DATA_KEY);
    return data ? JSON.parse(data) : undefined;
  };

  const setData = (data: IInboundApplicationFormData) => {
    Storage.local.setItem(FORM_DATA_KEY, JSON.stringify(data));
  };

  const clearData = () => {
    if (getFormData()) {
      Storage.local.removeItem(FORM_DATA_KEY);
    }
  };

  return {
    getFormData,
    setData,
    clearData,
  };
};
